import TimeLine from '../Timeline/Timeline.vue'

export default {
  components: { TimeLine },
  name: 'DeviceInfo',
  props: {
    identity: {
      required: true,
      type: String
    },
    owner: String,
    guests: Array,
    fields: {
      type: Array,
      default: () => []
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/DeviceInfo/DeviceInfo.js